<template>
  <div class="knd-outro knd-wrapper" >
    <!-- <div class="knd-wrapper-inner">
      <div>
        <SoundSnippet 
          :show="true"
          :src="ASSETS + '' + data.teaserquote.data.attributes.url">
            {{data.teasertext}}
        </SoundSnippet>
      </div>
    </div> -->
    
    <div class="knd-wrapper-inner">
      <div v-html="data.outro"></div>
    </div>

</div>
</template>

<script>
  import { ref } from "vue";

  import SoundSnippet from '@/components/soundsnippet';

  export default {
    name: 'Scrolly',
    components: {SoundSnippet},
    data() {
      return {
        data: this.$store.getters.data,
        ASSETS: process.env.VUE_APP_ASSETS,
      }
    },      
}

</script>

<style lang="scss">
  .knd-outro {
    padding-top: 5em;
    padding-bottom: 5em;
    min-height: 50vh;
  }


</style>